<div class="card w-100 h-100 m-2">
  <div class="card-header">
    <h2 class="mb-0">Notifications</h2>
  </div>

  <div class="card-body">
    <div class="container">
      <div *ngIf="loading" class="text-center text-muted py-5">
        <div class="spinner-border"></div>
        <p>Loading notifications...</p>
      </div>

      <div *ngIf="!loading && notificationsResults">
        <div class="list-group">
          <button
            *ngFor="let n of notificationsResults.notifications"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-start"
            [class]="{ 'fw-bold': !n.isSeen }"
            (click)="notificationClicked(n.id)"
          >
            <div>
              <div>{{ n.content }}</div>
              <small class="text-muted">{{
                n.dateCreated | date : "medium"
              }}</small>
            </div>
            <i
              *ngIf="!n.isSeen"
              class="bi bi-circle-fill text-primary ms-2"
              style="font-size: 0.6rem"
            ></i>
          </button>
        </div>
      </div>

      <div
        *ngIf="!loading && !notificationsResults?.notifications?.length"
        class="text-center text-muted py-5"
      >
        No notifications yet.
      </div>
    </div>
  </div>

  <div
    class="card-footer"
    *ngIf="!loading && notificationsResults?.notifications?.length"
  >
    <div class="container d-flex justify-content-between align-items-center">
      <button
        class="btn btn-outline-secondary"
        (click)="prevPage()"
        [disabled]="notificationsResults?.currentPage === 1"
      >
        ‹ Previous
      </button>
      <span>
        Page {{ notificationsResults?.currentPage }} of
        {{ notificationsResults?.totalPages }}
      </span>
      <button
        class="btn btn-outline-secondary"
        (click)="nextPage()"
        [disabled]="
          notificationsResults?.currentPage === notificationsResults?.totalPages
        "
      >
        Next ›
      </button>
    </div>
  </div>
</div>
